var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6128 5.57077L13.4706 2.42921C13.3661 2.32471 13.2421 2.24182 13.1056 2.18527C12.9691 2.12872 12.8227 2.09961 12.675 2.09961C12.5272 2.09961 12.3809 2.12872 12.2444 2.18527C12.1079 2.24182 11.9839 2.32471 11.8794 2.42921L3.20917 11.0994C3.10425 11.2035 3.02106 11.3274 2.96445 11.464C2.90784 11.6005 2.87893 11.7469 2.8794 11.8947V15.0369C2.8794 15.3353 2.99793 15.6215 3.20891 15.8324C3.41988 16.0434 3.70603 16.1619 4.0044 16.1619H15.8169C15.9661 16.1619 16.1092 16.1027 16.2146 15.9972C16.3201 15.8917 16.3794 15.7486 16.3794 15.5994C16.3794 15.4503 16.3201 15.3072 16.2146 15.2017C16.1092 15.0962 15.9661 15.0369 15.8169 15.0369H8.73784L16.6128 7.16194C16.7173 7.05747 16.8002 6.93344 16.8568 6.79693C16.9133 6.66042 16.9424 6.51411 16.9424 6.36635C16.9424 6.21859 16.9133 6.07228 16.8568 5.93578C16.8002 5.79927 16.7173 5.67524 16.6128 5.57077ZM7.14667 15.0369H4.0044V11.8947L10.1919 5.70717L13.3342 8.84944L7.14667 15.0369ZM14.1294 8.0542L10.9878 4.91194L12.6753 3.22444L15.8169 6.3667L14.1294 8.0542Z",
    fill: "#45852E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.0fc6d6bfd3db52f98787e09d79cd9455.svg";
export { ForwardRef as ReactComponent };